import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { orderDateStyles } from "@dana/Widgets/OrderDetails/OrderProcessNumber";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

orderDateStyles.wrapper = mergeToNew(orderDateStyles.wrapper, {
  width: 12,
  css: css`
    display: flex;
    width: 100%;
    max-width: 100%;
    flex-direction: column;
    padding: 0px;
  `
});


orderDateStyles.titleText = mergeToNew(orderDateStyles.titleText, {
  css: css`
    margin-bottom: 0px;
    background: ${themeBackgrounds.lightGray};
    padding: 16px;
    width: 100%;
  `
});

orderDateStyles.orderDate = mergeToNew(orderDateStyles.orderDate, {
  css: css`
    padding: 4px;
  `
});